import axios, { Method, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { store } from '../store';
import { logout, setTokens } from '../modules/login/reducers';
import { API_URL } from './env';

const apiCall = async <T>(
  method: Method,
  url: string,
  data?: any,
  extraHeaders?: any,
  // responseType?: ResponseType, // This creates an issue if I just append. I should probably keep responseType and add onUploadProgress after or make it an object?
  // The existing calls use positional arguments. So I must preserve order.
  responseType?: ResponseType,
  onUploadProgress?: (progressEvent: any) => void
): Promise<AxiosResponse<T>> => {
  const { login } = store.getState();
  const token = login.accessToken;

  const headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
    ...extraHeaders,
  };

  if (data instanceof FormData || responseType === 'blob') {
    delete headers['Content-Type'];
  }

  const config: AxiosRequestConfig = {
    method,
    url: `${API_URL}${url}`,
    data,
    headers,
    responseType,
    onUploadProgress,
  };

  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await axios(config);
    return response;
  } catch (error: any) {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !(originalRequest.url && originalRequest.url.includes('/auth/login/refresh/'))
    ) {
      originalRequest._retry = true;
      const { refreshToken } = store.getState().login;

      if (refreshToken) {
        try {
          const refreshResponse = await axios.post(`${API_URL}/auth/login/refresh/`, {
            refresh: refreshToken
          });

          if (refreshResponse.data && refreshResponse.data.data) {
            const { access, refresh } = refreshResponse.data.data;

            store.dispatch(setTokens({ access, refresh }));

            if (originalRequest.headers) {
              originalRequest.headers['Authorization'] = `Bearer ${access}`;
            }

            return axios(originalRequest);
          }
        } catch (refreshError) {
          store.dispatch(logout());
        }
      } else {
        store.dispatch(logout());
      }
    }
    throw error;
  }
};

export default apiCall;
